import contactFrag from "./Contact";
import Country from "./Country";

const Artist = (props = {}) => {
  // Handle case where props is true (include defaults) vs object (use configured fields)
  const includeDefaults = props === true || Object.keys(props).length === 0;
  const propsObj = typeof props === "object" && props !== null ? props : {};

  const {
    contact = false,
    bornCountry = includeDefaults,
    bornCountryId = includeDefaults,
    bornDate = includeDefaults,
    bornTown = includeDefaults,
    confidential = includeDefaults,
    contactId = includeDefaults,
    copyright = includeDefaults,
    defaultFabRate = includeDefaults,
    defaultSplitRate = includeDefaults,
    droitdesuite = includeDefaults,
    mailingList = includeDefaults,
    name = includeDefaults,
    represented = includeDefaults,
    sageCost = includeDefaults,
    sharedDiscount = includeDefaults,
    terms = includeDefaults,
  } = propsObj;

  return `
  id
  ${bornCountry ? `bornCountry {
    ${Country}
  }` : ""}
  ${bornCountryId ? `bornCountryId` : ""}
  ${bornDate ? `bornDate` : ""}
  ${bornTown ? `bornTown` : ""}
  ${
    contact
      ? `contact {
      ${contactFrag(contact)}
    }`
      : ""
  }
  ${confidential ? `confidential` : ""}
  ${contactId ? `contactId` : ""}
  ${copyright ? `copyright` : ""}
  ${defaultFabRate ? `defaultFabRate` : ""}
  ${defaultSplitRate ? `defaultSplitRate` : ""}
  ${droitdesuite ? `droitdesuite` : ""}
  ${mailingList ? `mailingList` : ""}
  ${name ? `name` : ""}
  ${represented ? `represented` : ""}
  ${sageCost ? `sageCost` : ""}
  ${sharedDiscount ? `sharedDiscount` : ""}
  ${terms ? `terms` : ""}
`;
};

export default Artist;